import {css} from 'lit';

const global_css = css`
  * {
    font-size: 14px;
    font-family: 'Inter', sans-serif;
  }

  .fullscreen {
    position: absolute !important;
    z-index: 1000 !important;
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box !important;
    background: rgb(var(--background-color, 127, 127, 127)) !important;
  }

  option:hover,
  option::selection {
    background: linear-gradient(black, black);
  }

  runner-idle:focus {
    outline: none;
  }

  runner-idle.paused,
  runner-idle.paused:focus {
    outline: 4px red solid;
    outline-offset: -4px;
  }

  .locked {
    display: none;
  }

  .new {
    outline: 4px solid rgb(var(--alert-color, red));
    /* box-shadow: 0px 0px 0px 4px red; */
    border-radius: 4px;
  }

  @keyframes blink {
    from,
    to {
      outline-color: rgb(var(--alert-color, red));
    }

    50% {
      outline-color: rgb(var(--black, black));
    }
  }

  .unlockables-entry-hovered {
    outline: 4px solid rgb(var(--black, black));
    animation: blink 0.5s infinite;
  }

  .hiddenByPlayer {
    color: #222;
    background-color: #888;
    border: 1px solid black;
  }

  .nowrap {
    white-space: nowrap;
  }

  .danger {
    color: red;
  }
  .danger-bg {
    background-color: red !important;
  }

  .expand {
    width: 100%;
  }

  .row-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .row-container > * {
    margin: 4px;
  }

  .chip {
    border: 1px solid black;
    border-radius: 4px;
    padding: 2px 4px;
    transition: all 0.2s ease-in-out;
    background: #fff2;
  }

  div.options-container {
    overflow-y: auto;
    max-height: 18em;
  }

  h1,
  h1 * {
    margin: 0px;
    font-size: 1.5rem;
  }

  h2,
  h3,
  h4 {
    margin: 0px;
    font-size: 1.1rem;
  }

  h4 span {
    font-size: 0.8em;
    font-weight: normal;
    color: #000a;
  }

  .subheader,
  .subheader * {
    font-size: 0.9rem;
    color: #000a;
  }

  .preference-active {
    background-color: #fff2;
  }

  hr {
    border: none;
    border-top: 2px solid #0004;
  }

  .svg-container > {
    transform: translateY(-100%);
  }

  .js-plotly-plot .modebar {
    display: flex;
  }

  button {
    background: transparent;
    border-radius: 4px;
  }
  button:hover {
    background: #0004;
  }

  /* Checkboxes - All*/

  input[type='checkbox'] {
    display: none;
  }

  input[type='checkbox']:hover + label {
    background: #0002;
  }

  input[type='checkbox']:active + label {
    background: #0006;
  }

  input[type='checkbox']:checked + label {
    background: #0004;
  }

  input[type='checkbox']:checked:hover + label {
    background: #0004;
  }

  input[type='checkbox']:checked:active + label {
    background: #0002;
  }
  /* Checkboxes - Filter chips */

  input[type='checkbox'].filter:checked + label {
    border-color: #0002;
  }

  input[type='checkbox'].filter:checked + label:before {
    content: '✓';
    font-weight: bold;
  }

  /* Top-level colors, a la DF */

  :root {
    --white: 255, 255, 255;
    --black: 0, 0, 0;
    --red: 230, 0, 0;
    --light-red: 255, 180, 180;
    --green: 0, 200, 0;
    --light-green: 75, 170, 60;
    --blue: 0, 0, 200;
    --light-blue: 143, 218, 255;
    --yellow: 210, 230, 00;
    --orange: 220, 60, 20;
    --brown: 123, 63, 0;
    --light-brown: 200, 148, 4;
    --purple: 123, 24, 245;
    --dark-purple: 70, 50, 130;
    --light-purple: 190, 165, 200;
    --dark-magenta: 75, 0, 75;
    --maroon: 170, 60, 60;

    --alert-color: 255, 0, 0;
    --stamina-color: var(--light-brown);
    --mana-color: 0, 127, 191;
    --health-color: var(--red);
  }

  /*** In-game tag colors ***/

  /** Activities first **/
  .rest {
    --none-color: var(--stamina-color);
  }

  .walk,
  [class*='walk'],
  [class*='run'],
  .run {
    --value-color: var(--stamina-color);
    --none-color: var(--light-blue);
  }
  .jog,
  [class*='jog'] {
    --value-color: var(--stamina-color);
    --none-color: var(--red);
  }

  [class*='jump'] {
    --value-color: var(--yellow);
    --none-color: var(--orange);
  }
  [class*='dash'] {
    --value-color: var(--orange);
    --none-color: var(--yellow);
  }
  .trainStrength {
    --value-color: var(--stamina-color);
    --none-color: var(--orange);
  }

  .trainSpeed {
    --value-color: var(--stamina-color);
    --none-color: var(--yellow);
  }

  .focus {
    --value-color: var(--stamina-color);
    --none-color: var(--light-red);
  }

  .hunt {
    --value-color: var(--stamina-color);
    --none-color: 170, 60, 60;
  }

  .gather {
    --value-color: var(--stamina-color);
    --none-color: var(--purple);
  }

  .cook {
    --value-color: var(--orange);
    --none-color: var(--black);
  }

  .eat {
    --value-color: var(--maroon);
    --none-color: var(--light-green);
  }

  .fight {
    --value-color: var(--health-color);
  }

  .distance {
    --value-color: var(--light-blue);
    --none-color: var(--blue);
  }

  .stamina,
  .staminaExp {
    --value-color: var(--stamina-color);
  }

  .health,
  .healthExp {
    --value-color: var(--health-color);
    --none-color: var(--light-red);
  }

  .mana,
  .manaExp {
    /* --value-color: var(--blue); */
    --value-color: var(--mana-color);
  }

  .meditate,
  .walkingMeditation {
    --value-color: unset;
    --none-color: var(--mana-color);
  }

  .manaDepth {
    --value-color: var(--dark-purple);
    --none-color: var(--white);
  }

  .spaceMagic {
    --value-color: var(--dark-magenta);
    --none-color: var(--white);
  }

  .time,
  .timeMagic {
    --none-color: var(--dark-magenta);
    --value-color: var(--white);
  }

  .sanity,
   /* Overloaded, spell and resource. Luckily it's okay*/
  .light,
  .lightMagic {
    --value-color: var(--white);
    --none-color: var(--black);
  }

  .fire,
  .fireMagic,
  .lightFire,
  .flame {
    --value-color: var(--orange);
    --none-color: var(--light-red);
  }

  .nutrition {
    --value-color: var(--light-green);
  }

  .meat {
    --value-color: var(--maroon);
    --none-color: var(--light-red);
  }
  .cookedMeat {
    --value-color: var(--brown);
    --none-color: var(--light-red);
  }
  .berry {
    --value-color: var(--purple);
    --none-color: var(--light-purple);
  }
  .pemmican {
    --value-color: var(--brown);
    --none-color: var(--light-purple);
  }
  .fish,
  .fishing {
    --value-color: var(--blue);
    --none-color: var(--light-red);
  }
  .bait {
    --value-color: var(--light-red);
    --none-color: var(--blue);
  }

  .wood {
    --value-color: var(--brown);
    --none-color: var(--light-brown);
  }

  ri-stat {
    --none-color: 0, 0, 0;
    --value-color: var(--white);
  }

  .speed {
    --value-color: var(--yellow);
  }

  .strength {
    --value-color: var(--orange);
    --none-color: var(--white);
  }

  .constitution {
    --value-color: var(--red);
    --none-color: var(--white);
  }

  .wisdom {
    --value-color: var(--purple);
  }

  .perception {
    --value-color: var(--light-purple);
  }

  .fancy {
    border-radius: 4px;
    padding: 1px 2px;
    /* -webkit-text-stroke: 1px #0002; */
  }
  .fancy,
  .fancy select,
  .fancy option {
    background-color: rgb(var(--value-color, initial), 1);
  }
  .fancy,
  .fancy * {
    font-weight: bold;
    color: rgb(var(--none-color, initial));
  }

  .fancy.invert,
  .fancy.invert * {
    color: rgb(var(--value-color, initial));
    background-color: rgb(var(--none-color, initial), 1);
  }

  .fancy.invert,
  .fancy.cutout-background {
    background-color: rgb(var(--none-color, initial), 0.8);
  }

  .fancy.cutout,
  .fancy.cutout * {
    color: black;
    mix-blend-mode: screen;
  }

  .tippy-box {
    color: #000;
    background-color: #66ccfff0;
    border: 2px solid #0004;
    transition: all 1s ease-in-out;
    min-width: 200px;
    max-width: 1000px;
    line-height: 1.5;
  }

  .tippy-box[data-state='hidden'] {
    opacity: 0;
  }
  .tippy-box[data-state='visible'] {
    opacity: 1;
  }

  .tippy-content {
    margin: 4px;
  }

  .tippy-arrow:before {
    color: #66ccff;
  }

  .costeffect {
    font-weight: bold;
  }
`;

// This applies this as a global stylesheet as well, but it's still necessary to
// import it in every component.
// This make other top-level elements use the styles, like tippy tooltips or the tutorial modals.
// This is currently the least caniuse thing in this codebase.
if (global_css.styleSheet)
  document.adoptedStyleSheets = [global_css.styleSheet];

export default global_css;
